import { Component, OnInit, Input } from '@angular/core';

import { CurrencyDisclaimerFormatPricing } from '../interfaces/currency-disclamer-format-pricing.interface';
import { CruisePricing } from './interfaces/cruise-pricing.interface';
import { AppLocaleService } from '../services/app-locale/app-locale.service';

@Component({
    selector: 'dcl-format-currency',
    templateUrl: './format-currency.component.html',
    styleUrls: ['./format-currency.component.scss']
})
export class FormatCurrencyComponent implements OnInit {
    @Input() formatCurrency: CurrencyDisclaimerFormatPricing;
    @Input() convertedPricing: CruisePricing;
    @Input() disable?: boolean;
    @Input() isHover?: boolean;
    @Input() hideDecimals?: boolean = true;

    private language: string;
    pricingFormat: string;

    constructor(
        private appLocaleService: AppLocaleService,
    ) {}

    ngOnInit() {
        this.language = this.appLocaleService.acceptLanguage();
        this.replaceSeparators();
    }

    /**
     * Generate a new currency format according to the Dscribe service
     */
    replaceSeparators() {
        const total = this.hideDecimals ? Math.round(this.convertedPricing.total) : this.convertedPricing.total;
        const numParseFloat = String(total);
        const numParts = numParseFloat.split('.');
        let formattedIntegerPart = Number(numParts[0]).toLocaleString(this.language);

        // Replace a thousand separators with the custom separator
        formattedIntegerPart = formattedIntegerPart.replace(/[^0-9]/g, this.formatCurrency.thousandSeparator);

        if (numParts[1]) {
            formattedIntegerPart += this.formatCurrency.dollarCentSeparator + numParts[1];
        }

        this.pricingFormat = `${this.formatCurrency.currencySymbol}${formattedIntegerPart}`;
    }
}
